import {
  UPDATE_NUM_ENTRIES,
  UPDATE_IS_RESTORING_SCROLL_POSITION,
  TOGGLE_IS_ACTIVITY_VIDEO_MUTED
} from './feed.actions';

export function reducer(state, action) {
  switch (action.type) {
    case UPDATE_NUM_ENTRIES: {
      const { numEntries } = action.payload;
      return {
        ...state,
        numEntries
      };
    }
    case UPDATE_IS_RESTORING_SCROLL_POSITION: {
      const { status } = action.payload;
      return {
        ...state,
        isRestoringScrollPosition: status
      };
    }
    case TOGGLE_IS_ACTIVITY_VIDEO_MUTED: {
      const { muted } = action.payload;
      return {
        ...state,
        isActivityVideoMuted: muted
      };
    }
    default:
      throw new Error(`${action.type} - not recognized`);
  }
}

export default { reducer };
